/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { HeaderGroup, Header } from '@tanstack/react-table'
import UiTanstackTableHeaderRow from './UiTanstackTableHeaderRow'
import { TableInitBase } from 'utils/hooks/useTable'

interface UiTanstackTableHeaderGroupsProps<TData> {
    headerGroups: HeaderGroup<TData>[]
    tableInit: TableInitBase
    filterableHeaderIds: string[]
    renderHeaderFilter?: (
        header: Header<TData, unknown>,
        tableInit: TableInitBase
    ) => React.ReactNode
    renderHeaderTitleProps?: (
        header: Header<TData, unknown>,
        tableInit: TableInitBase
    ) => Record<string, unknown>
    searchVisibility: Record<string, boolean>
    onToggleSearch: (headerId: string) => void
    translate: (value: string) => string
    isBatchMode?: boolean
    renderBatchHeaderControl?: (
        header: Header<TData, unknown>,
        tableInit: TableInitBase
    ) => React.ReactNode
}

const UiTanstackTableHeaderGroups = <TData,>(
    props: UiTanstackTableHeaderGroupsProps<TData>
) => {
    return (
        <>
            {props.headerGroups.map((headerGroup) => (
                <UiTanstackTableHeaderRow
                    key={headerGroup.id}
                    headerGroup={headerGroup}
                    tableInit={props.tableInit}
                    filterableHeaderIds={props.filterableHeaderIds}
                    renderHeaderFilter={props.renderHeaderFilter}
                    renderHeaderTitleProps={props.renderHeaderTitleProps}
                    searchVisibility={props.searchVisibility}
                    onToggleSearch={props.onToggleSearch}
                    translate={props.translate}
                    isBatchMode={props.isBatchMode}
                    renderBatchHeaderControl={props.renderBatchHeaderControl}
                />
            ))}
        </>
    )
}

export default UiTanstackTableHeaderGroups
